export const WalletTransferType = {
  WalletCredit: "wallet_credit",
  WalletDebitCard: "wallet_debit_card",
  WalletDebitBank: "wallet_debit_bank",
} as const;
export type WalletTransferType =
  (typeof WalletTransferType)[keyof typeof WalletTransferType];
